import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { entityTypeEndpoints } from '@/lib/api/endpoints';
import { entityTypeKeys } from '@/lib/queryKeys';

export interface EntityType {
  id: string;
  label: string;
}

export function useEntityTypes() {
  return useApiQuery<EntityType[]>({
    queryKey: entityTypeKeys.all(),
    queryFn: () => apiGet<EntityType[]>(operationsClient, entityTypeEndpoints.list()),
    showErrorToast: false,
  });
}
